(function () {
  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      var args = arguments,
        ctx = this;
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  function initGalleryHeightFix(list) {
    var items = Array.prototype.slice.call(list.querySelectorAll('.product__media-item'));
    if (!items.length) return;

    function currentItem() {
      var listRect = list.getBoundingClientRect();
      var center = listRect.left + listRect.width / 2;
      var closest = items[0];
      var closestDist = Infinity;
      items.forEach(function (item) {
        var r = item.getBoundingClientRect();
        var itemCenter = r.left + r.width / 2;
        var dist = Math.abs(itemCenter - center);
        if (dist < closestDist) {
          closestDist = dist;
          closest = item;
        }
      });
      return closest;
    }

    function updateHeight() {
      if (window.matchMedia('(min-width: 750px)').matches) {
        list.style.height = '';
        return;
      }
      var item = currentItem();
      if (!item) return;
      var h = item.getBoundingClientRect().height;
      if (h > 0) list.style.height = h + 'px';
    }

    var onScroll = debounce(updateHeight, 60);
    list.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', debounce(updateHeight, 150));
    window.addEventListener('orientationchange', debounce(updateHeight, 150));

    items.forEach(function (item) {
      var img = item.querySelector('img');
      if (img) {
        if (img.complete) {
          updateHeight();
        } else {
          img.addEventListener('load', updateHeight);
        }
      }
    });

    // Re-measure on variant change / re-render inside the gallery
    var observer = new MutationObserver(debounce(updateHeight, 100));
    observer.observe(list, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });

    requestAnimationFrame(updateHeight);
    setTimeout(updateHeight, 300);
  }

  function init() {
    document.querySelectorAll('.product__media-list.slider--mobile').forEach(initGalleryHeightFix);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
